import { ReactElement } from "react";
import styled from "styled-components";
import {
  AccordionMultipleProps,
  AccordionSingleProps,
  Root as RootBase,
} from "@radix-ui/react-accordion";
import { Props as AccordionItemProps } from "./accordion-item/AccordionItem.Parts";

// TEXT

// STYLES
export const Root = styled(RootBase)<AccordionRootProps>`
  width: ${({ $width }) => $width ?? "100%"};
`;

// DATA

// TYPES
type BaseAccordionProps = {
  /** You must pass one or more `<AccordionItemComp>` elements */
  children:
    | ReactElement<AccordionItemProps>
    | ReactElement<AccordionItemProps>[];
  /**
   * Defines the width of the accordion
   * @default 100%
   */
  width?: string;
  /**
   * When type is "single", allows closing content when clicking trigger for an open item.
   * @default true
   */
  collapsible?: boolean;
};

export type SingleAccordion = {
  /**
   * Determines whether one or multiple items can be opened at the same time.
   * @default single
   */
  type?: "single";
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
} & Omit<
  AccordionSingleProps,
  | "type"
  | "defaultValue"
  | "value"
  | "onValueChange"
  | "asChild"
  | "orientation"
> &
  BaseAccordionProps;

export type MultipleAccordion = {
  type: "multiple";
  defaultValue?: string[];
  value?: string[];
  onValueChange?: (value: string[]) => void;
} & Omit<
  AccordionMultipleProps,
  | "type"
  | "defaultValue"
  | "value"
  | "onValueChange"
  | "asChild"
  | "orientation"
> &
  BaseAccordionProps;

export type Props = SingleAccordion | MultipleAccordion;

type AccordionRootProps = {
  $width?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
